import useStateStore from 'services/store';
import './in-or-out.scss';

const inOrOut = [
  {
    id: 'tucked-in',
    name: 'Tucked In',
  },
  {
    id: 'untucked',
    name: 'Untucked',
  },
  {
    id: 'both',
    name: 'Both',
  },
];

const InOrOut = () => {
  const { inforStepValues: steps, changeInforStepValues } = useStateStore();
  const handleChangeSteps = (id: string) => {
    changeInforStepValues('in-or-out', id);
  };

  return (
    <div className="body-container">
      <div className="infor">
        <div className="title">IN OR OUT?</div>
        <div className="confirm">How do you usually wear your shirts?</div>
      </div>
      <div className="text-options in-or-out">
        {inOrOut.map((option) => (
          <div
            onClick={() => handleChangeSteps(option.id)}
            key={option.id}
            className={`text-option ${
              steps['in-or-out'] === option.id ? 'active' : ''
            }`}
          >
            {option.name}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InOrOut;
